module.exports = __webpack_public_path__ + "img/PriceCheck_EGM.637ead9a.png";